export default function /* @ngInject */ countryData(cachedResource, config) {
    return cachedResource(config.accountsApiUrl + '/api/v1/countries');
}



// WEBPACK FOOTER //
// ./data/services/country-data.js